/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Shockwave_TherapyInputs */

const en_service_type_shockwave_therapy = /** @type {(inputs: Service_Type_Shockwave_TherapyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shockwave therapy`)
};

const pl_service_type_shockwave_therapy = /** @type {(inputs: Service_Type_Shockwave_TherapyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fala uderzeniowa`)
};

/**
* | output |
* | --- |
* | "Shockwave therapy" |
*
* @param {Service_Type_Shockwave_TherapyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_shockwave_therapy = /** @type {((inputs?: Service_Type_Shockwave_TherapyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Shockwave_TherapyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_shockwave_therapy(inputs)
	return en_service_type_shockwave_therapy(inputs)
});